<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  action: {
    type: Function,
    default: null,
  },
});

const isTitleClickable = computed(() => {
  return props.action !== null && !props.loading;
});
</script>

<template>
  <v-row class="flex-column ga-2 w-100" no-gutters>
    <v-col v-if="title && isTitleClickable">
      <v-btn
        variant="text"
        color="on-surface"
        class="justify-start text-subtitle-1 font-weight-bold pa-2"
        append-icon="mdi-chevron-right"
        height="40"
        block
        @click="action"
      >
        <span class="text-decoration-underline">
          {{ title }}
        </span>
      </v-btn>
    </v-col>
    <v-col v-if="title && !isTitleClickable" class="d-flex align-center justify-start" style="min-height: 40px">
      <h7 class="text-subtitle-1 font-weight-bold pa-2" style="height: 40px"> {{ title }} </h7>
    </v-col>
    <v-col class="d-flex flex-1-1 flex-column pl-4 pr-1 ga-2" style="min-height: 40px">
      <slot></slot>
    </v-col>
  </v-row>
</template>
